import { AdpImportFileDefinitionSelectResponse } from "@herbjoy/apex-api-models";
import { IComponentOptions } from "angular";
import { EventEmitter } from "../../../common/components/event-emitter";
import templateUrl from "./adp-config-list.component.html";

export const AdpConfigListComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        adpImportFileDefinitions: "<",
        delete: "&onDelete"
    },
    controller: class {
        adpImportFileDefinitions: AdpImportFileDefinitionSelectResponse[];
        delete: EventEmitter<{ id: number }>;

        onDeleteDefinition(definition: AdpImportFileDefinitionSelectResponse) {
            if (!confirm(`The ADP import definition ${definition.name} will be deleted`)) {
                return;
            }

            this.delete({ $event: { id: definition.id } });
        }


    }
};
